module.exports = __webpack_public_path__ + "img/oxxo.4751f450.png";